module.exports = __webpack_public_path__ + "static/media/067-kenya.d9b79c8f.svg";